export function chatListAccountUsersUrl(accountChatId) {
  if (!accountChatId) {
    return;
  }

  return `https://chat.agendor.com.br/app/accounts/${accountChatId}/settings/agents/list`;
}
